module.exports = __webpack_public_path__ + "static/media/choithramsApple.db414ddb.png";